// module.exports = {
//     user: 'bug.send.hj@gmail.com',
//     pass: 'hongjee0903'
// };

module.exports = {
  aws: {
    accessID: "AKIAYWSWUVAHKISOMPWC",
    secretAccessKey: "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",
    ses: {
      from: {
        default: '"repl" <repl@salin.co.kr>',
      },
      region: "ap-northeast-2",
    },
  },
};
